const moduleLoader = {
    namespaced: true,
    state: {
        storeRecipeData: false,
    },
    getters: {
        getStoreRecipeData(state) {
            return state.storeRecipeData;
        },
    },
    mutations: {
        setStoreRecipeData(state, payLoad) {
            state.storeRecipeData = payLoad;
        },
    },
};
export default moduleLoader;
